/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RestService } from './rest.service';
import {
  LoginRequest,
  AuthenticationService,
  MobileRequest,
} from '@ews/users-management';
import { StorageService } from './storage.service';
import { GeolocationService } from './geo-location.service';
import { StateService } from './state.service';
import { UnreadChatsService } from './unread-chats.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public token: string | null;
  public username: any;
  public userId: any;
  public loginError = '';

  constructor(
    private http: HttpClient,
    private rest: RestService,
    private auth: AuthenticationService,
    private router: Router,
    private storage: StorageService,
    private geolocationService: GeolocationService,
    private stateService: StateService,
    private unreadChatsService: UnreadChatsService
  ) {}

  public loginNew(
    rememberMe: boolean,
    username: string,
    password: string
  ): Observable<boolean> {
    return new Observable<boolean>((subscriber) => {
      const form = new LoginRequest(username, password, rememberMe);
      this.auth.login(form).subscribe({
        next: (response) => {
          console.log('Response loginNew => ', response);
          this.unreadChatsService.startPolling();
          subscriber.next(true);
        },
        error: (error) => {
          console.log('Error loginNew => ', error);
          subscriber.error(error);
        },
        complete: () => {
          subscriber.complete();
        },
      });
    });
  }

  public loginNewMobile(mobileId: string): Observable<boolean> {
    return new Observable<boolean>((subscriber) => {
      const mobileRequest = new MobileRequest(mobileId);
      this.auth.mobileLogin(mobileRequest).subscribe({
        next: (response) => {
          console.log('Response loginNewMobile => ', response);
          this.unreadChatsService.startPolling();
          subscriber.next(true);
        },
        error: (error) => {
          console.log('Error loginNewMobile => ', error);
          subscriber.error(error);
        },
        complete: () => {
          subscriber.complete();
        },
      });
    });
  }

  public addMobileId(mobileId: string): Observable<boolean> {
    return new Observable<boolean>((subscriber) => {
      const headers = new HttpHeaders({});

      const options = {
        headers,
      };
      const mobileRequest = { mobileId };
      this.http
        .post(
          this.rest.baseUrl + 'authentication/addmobileid',
          {
            mobileId,
          },
          options
        )
        .subscribe({
          next: (response) => {
            console.log('Response addMobileId => ', response);
            subscriber.next(true);
          },
          error: (error) => {
            console.log('Error addMobileId => ', error);
            subscriber.error(error);
          },
          complete: () => {
            subscriber.complete();
          },
        });
    });
  }

  public removeMobileId(mobileId: string): Observable<boolean> {
    return new Observable<boolean>((subscriber) => {
      const headers = new HttpHeaders({});

      const options = {
        headers,
      };
      const mobileRequest = { mobileId };
      this.http
        .post(
          this.rest.baseUrl + 'authentication/removeMobileid',
          {
            mobileId,
          },
          options
        )
        .subscribe({
          next: (response) => {
            console.log('Response removeMobileId => ', response);
            subscriber.next(true);
          },
          error: (error) => {
            console.log('Error removeMobileId => ', error);
            subscriber.error(error);
          },
          complete: () => {
            subscriber.complete();
          },
        });
    });
  }

  public async logoutNew() {
    this.storage.get('hashcode').then((val) => {
      this.storage.removeStorageItem('hashcode');
      this.removeMobileId(val).subscribe((resultRemove) => {
        this.auth.logout().subscribe((result) => {
          console.log('logged out');
          this.logout();

          this.router.navigate(['login']);
        });
      });
    });
  }

  logout(): void {
    this.token = null;
    this.username = null;
    this.rest.username = null;
    this.userId = null;
    this.stateService.clearState();
    this.geolocationService.cleanupAfterTurnOff();
    this.unreadChatsService.stopPolling();
  }
}

export interface ValidationResult {
  [key: string]: boolean;
}
